import { motion } from "framer-motion";
import { Pill, Shield, Recycle, Palette } from "lucide-react";
import pharmacyBags from "@/assets/pharmacy-bags.jpg";

const features = [
  {
    icon: Palette,
    title: "Personnalisation complète",
    description: "Impression de votre logo, couleurs et design sur mesure",
  },
  {
    icon: Shield,
    title: "Conformité sanitaire",
    description: "Emballages certifiés pour le contact alimentaire et médical",
  },
  {
    icon: Recycle,
    title: "Éco-responsable",
    description: "Matériaux biodégradables et recyclables certifiés FSC",
  },
];

const PharmacySection = () => {
  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
            className="relative"
          >
            <div className="relative overflow-hidden rounded-2xl shadow-float">
              <img
                src={pharmacyBags}
                alt="Sacs personnalisés pour pharmacie"
                className="w-full h-auto object-cover"
              />
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-primary/10 rounded-full blur-2xl" />
            <div className="absolute -top-6 -left-6 w-24 h-24 bg-eco/10 rounded-full blur-xl" />
          </motion.div>

          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
            className="space-y-8"
          >
            {/* Badge */}
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary/10 rounded-full">
              <Pill className="w-4 h-4 text-primary" />
              <span className="text-sm font-medium text-primary">
                Secteur Pharmacie
              </span>
            </div>

            {/* Title */}
            <div>
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-primary mb-4">
                UNIVERS PHARMACEUTIQUE
              </h2>
              <div className="w-20 h-1 bg-primary rounded-full" />
            </div>

            {/* Description */}
            <div className="space-y-4 text-muted-foreground">
              <p className="text-lg">
                La demande croissante d'emballages pharmaceutiques biodégradables 
                est motivée par les progrès technologiques et les normes réglementaires, 
                ainsi que par la nécessité de réduire les déchets.
              </p>
              <p>
                Notre emballage écologique répond aux exigences de l'industrie, 
                aux objectifs d'impact environnemental et satisfait les exigences 
                esthétiques de nos clients.
              </p>
            </div>

            {/* Features */}
            <div className="space-y-4 pt-4">
              {features.map((feature, index) => (
                <motion.div
                  key={feature.title}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4, delay: index * 0.1 }}
                  viewport={{ once: true }}
                  className="flex items-start gap-4 p-4 bg-muted/30 rounded-xl hover:bg-muted/50 transition-colors"
                >
                  <div className="flex-shrink-0 w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                    <feature.icon className="w-5 h-5 text-primary" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-foreground mb-1">
                      {feature.title}
                    </h3>
                    <p className="text-sm text-muted-foreground">
                      {feature.description}
                    </p>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default PharmacySection;
